import { defineStore } from 'pinia'

export const useAuthStore = defineStore({
    id: "auth",

    state () {
        return {
            user: null
        }
    },

    getters: {
        loggedIn (state) {
            return Boolean(state.user)
        }
    },

    actions: {
        setUser (user) {
            this.user = user;
        },

        patchUser (key, value) {
            this.user[key] = value;
        },

        async fetch () {
            // Call it once
            if (this.user) return;
            
            // Try to get user profile
            // All the user's cookies will be sent by server before cookieStore hydration 🍪
            try {
                const userData = await this.$nuxt.$axios.$get('/user/user')
                if (userData) this.setUser(userData);
            } catch (e) {
                console.log(e);
                this.user = null;
            }
        },
    }
})